import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "./cn";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap [&_svg]:size-3.5 [&_svg]:shrink-0",
  {
    variants: {
      tone: {
        neutral: "border-border bg-neutral-soft text-neutral-foreground",
        success: "border-success-border bg-success-soft text-success",
        warning: "border-warning-border bg-warning-soft text-warning",
        danger: "border-destructive-border bg-destructive-soft text-destructive",
        info: "border-info-border bg-info-soft text-info",
        brass: "border-brass-border bg-brass-soft text-brass-strong",
        outline: "border-border bg-transparent text-foreground",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

/** The soft pill of the redesign (add it to a `Badge` or `StatusBadge`): no visible border, 13 px semibold, a little more room than the kit badge. */
export const pillClass = "gap-[5px] border-transparent px-[9px] py-[3px] text-[13px] font-semibold";

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>["tone"]>;

/** A small label. It carries no meaning in colour alone: for a status use `StatusBadge`, which always adds a glyph. */
export function Badge({
  className,
  tone,
  ...props
}: ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
